import api from './api';
import { nullableUuid } from '@/utils/uuid';

export interface Produto {
  id: string;
  codigo: string;
  descricao: string;
  tipo_produto_id?: string | null;
  tipo_produto?: string | null;
  tipo_produto_codigo?: string | null;
  tipo_produto_descricao?: string | null;
  unidade: string;
  estoque_atual?: number;
  ativo: boolean;
  custo_padrao?: number | null;
  estoque_minimo?: number | null;
  dias_validade?: number | null;
  ncm?: string | null;
  controla_lote: boolean;
  codigo_barras?: string | null;
  codigo_erp?: string | null;
}

export interface ProdutoInput {
  codigo?: string;
  descricao: string;
  tipo_produto_id?: string | null;
  unidade: string;
  controla_lote?: boolean;
  dias_validade?: number | null;
  ncm?: string | null;
  custo_padrao?: number | null;
  estoque_minimo?: number | null;
  ativo?: boolean;
  codigo_barras?: string | null;
  codigo_erp?: string | null;
}

export interface ProdutoFilters {
  tipo_produto?: string;
  ativo?: boolean;
  search?: string;
}

const ENDPOINT = '/industrializacao/produto';

const produtoService = {
  async listar(filters: ProdutoFilters = {}): Promise<Produto[]> {
    const response = await api.get<Produto[]>(ENDPOINT, { params: filters });
    return response.data;
  },
  async obter(id: string): Promise<Produto> {
    const response = await api.get<Produto>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: ProdutoInput): Promise<Produto> {
    const response = await api.post<Produto>(ENDPOINT, { ...data, tipo_produto_id: nullableUuid(data.tipo_produto_id) });
    return response.data;
  },
  async atualizar(id: string, data: Partial<ProdutoInput>): Promise<Produto> {
    const payload = data.tipo_produto_id === undefined ? data : { ...data, tipo_produto_id: nullableUuid(data.tipo_produto_id) };
    const response = await api.put<Produto>(`${ENDPOINT}/${id}`, payload);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
};

export default produtoService;
